//NEW
export const PUBLIC_INVITE_INFO_REQUEST = "PUBLIC_INVITE_INFO_REQUEST";
export const PUBLIC_INVITE_INFO_SUCCESS = "PUBLIC_INVITE_INFO_SUCCESS";
export const PUBLIC_INVITE_INFO_FAIL = "PUBLIC_INVITE_INFO_FAIL";
export const PUBLIC_INVITE_INFO_RESET = "PUBLIC_INVITE_INFO_RESET";

export const PUBLIC_ACCEPT_INVITE_REQUEST = "PUBLIC_ACCEPT_INVITE_REQUEST";
export const PUBLIC_ACCEPT_INVITE_SUCCESS = "PUBLIC_ACCEPT_INVITE_SUCCESS";
export const PUBLIC_ACCEPT_INVITE_FAIL = "PUBLIC_ACCEPT_INVITE_FAIL";
export const PUBLIC_ACCEPT_INVITE_RESET = "PUBLIC_ACCEPT_INVITE_RESET";

export const PUBLIC_PORTAL_PATIENT_DETAILS_REQUEST =
  "PUBLIC_PORTAL_PATIENT_DETAILS_REQUEST";
export const PUBLIC_PORTAL_PATIENT_DETAILS_SUCCESS =
  "PUBLIC_PORTAL_PATIENT_DETAILS_SUCCESS";
export const PUBLIC_PORTAL_PATIENT_DETAILS_FAIL =
  "PUBLIC_PORTAL_PATIENT_DETAILS_FAIL";
export const PUBLIC_PORTAL_PATIENT_DETAILS_RESET =
  "PUBLIC_PORTAL_PATIENT_DETAILS_RESET";

export const PUBLIC_PORTAL_PATIENT_VERIFY_PIN_REQUEST =
  "PUBLIC_PORTAL_PATIENT_VERIFY_PIN_REQUEST";
export const PUBLIC_PORTAL_PATIENT_VERIFY_PIN_SUCCESS =
  "PUBLIC_PORTAL_PATIENT_VERIFY_PIN_SUCCESS";
export const PUBLIC_PORTAL_PATIENT_VERIFY_PIN_FAIL =
  "PUBLIC_PORTAL_PATIENT_VERIFY_PIN_FAIL";
export const PUBLIC_PORTAL_PATIENT_VERIFY_PIN_RESET =
  "PUBLIC_PORTAL_PATIENT_VERIFY_PIN_RESET";

export const PUBLIC_PORTAL_GET_TREATMENT_PLANS_REQUEST =
  "PUBLIC_PORTAL_GET_TREATMENT_PLANS_REQUEST";
export const PUBLIC_PORTAL_GET_TREATMENT_PLANS_SUCCESS =
  "PUBLIC_PORTAL_GET_TREATMENT_PLANS_SUCCESS";
export const PUBLIC_PORTAL_GET_TREATMENT_PLANS_FAIL =
  "PUBLIC_PORTAL_GET_TREATMENT_PLANS_FAIL";
export const PUBLIC_PORTAL_GET_TREATMENT_PLANS_RESET =
  "PUBLIC_PORTAL_GET_TREATMENT_PLANS_RESET";

export const PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_REQUEST =
  "PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_REQUEST";
export const PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_SUCCESS =
  "PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_SUCCESS";
export const PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_FAIL =
  "PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_FAIL";
export const PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_RESET =
  "PUBLIC_PORTAL_TREATMENT_PLAN_APPROVE_RESET";

export const PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_REQUEST =
  "PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_REQUEST";
export const PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_SUCCESS =
  "PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_SUCCESS";
export const PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_FAIL =
  "PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_FAIL";
export const PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_RESET =
  "PUBLIC_PORTAL_TREATMENT_PLAN_CANCEL_RESET";

export const PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_REQUEST =
  "PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_REQUEST";
export const PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_SUCCESS =
  "PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_SUCCESS";
export const PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_FAIL =
  "PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_FAIL";
export const PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_RESET =
  "PUBLIC_PORTAL_TREATMENT_PLAN_DOWNLOADPDF_RESET";

export const PUBLIC_CHECK_USER_INVITE_REQUEST =
  "PUBLIC_CHECK_USER_INVITE_REQUEST";
export const PUBLIC_CHECK_USER_INVITE_SUCCESS =
  "PUBLIC_CHECK_USER_INVITE_SUCCESS";
export const PUBLIC_CHECK_USER_INVITE_FAIL = "PUBLIC_CHECK_USER_INVITE_FAIL";
export const PUBLIC_CHECK_USER_INVITE_RESET = "PUBLIC_CHECK_USER_INVITE_RESET";

// OLD
export const PUBLIC_PATIENT_TREATMENT_PLAN_LIST_REQUEST =
  "PUBLIC_PATIENT_TREATMENT_PLAN_LIST_REQUEST";
export const PUBLIC_PATIENT_TREATMENT_PLAN_LIST_SUCCESS =
  "PUBLIC_PATIENT_TREATMENT_PLAN_LIST_SUCCESS";
export const PUBLIC_PATIENT_TREATMENT_PLAN_LIST_FAIL =
  "PUBLIC_PATIENT_TREATMENT_PLAN_LIST_FAIL";
export const PUBLIC_PATIENT_TREATMENT_PLAN_LIST_RESET =
  "PUBLIC_PATIENT_TREATMENT_PLAN_LIST_RESET";

export const PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_REQUEST =
  "PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_REQUEST";
export const PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_SUCCESS =
  "PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_SUCCESS";
export const PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_FAIL =
  "PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_FAIL";
export const PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_RESET =
  "PUBLIC_PATIENT_TREATMENT_PLAN_DETAILS_RESET";

export const PUBLIC_TENANT_DETAILS_REQUEST = "PUBLIC_TENANT_DETAILS_REQUEST";
export const PUBLIC_TENANT_DETAILS_SUCCESS = "PUBLIC_TENANT_DETAILS_SUCCESS";
export const PUBLIC_TENANT_DETAILS_FAIL = "PUBLIC_TENANT_DETAILS_FAIL";
export const PUBLIC_TENANT_DETAILS_RESET = "PUBLIC_TENANT_DETAILS_RESET";

export const PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_REQUEST =
  "PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_REQUEST";
export const PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_SUCCESS =
  "PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_SUCCESS";
export const PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_FAIL =
  "PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_FAIL";
export const PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_RESET =
  "PUBLIC_PATIENT_APPROVE_TREATMENT_PLAN_RESET";

export const PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_REQUEST =
  "PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_REQUEST";
export const PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_SUCCESS =
  "PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_SUCCESS";
export const PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_FAIL =
  "PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_FAIL";
export const PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_RESET =
  "PUBLIC_PATIENT_CANCEL_TREATMENT_PLAN_RESET";

export const PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_REQUEST =
  "PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_REQUEST";
export const PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_SUCCESS =
  "PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_SUCCESS";
export const PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_FAIL =
  "PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_FAIL";
export const PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_RESET =
  "PUBLIC_PATIENT_DOWNLOADPDF_TREATMENT_PLAN_RESET";

export const PUBLIC_COURSES_LIST_REQUEST = "PUBLIC_COURSES_LIST_REQUEST";
export const PUBLIC_COURSES_LIST_SUCCESS = "PUBLIC_COURSES_LIST_SUCCESS";
export const PUBLIC_COURSES_LIST_FAIL = "PUBLIC_COURSES_LIST_FAIL";
export const PUBLIC_COURSES_LIST_RESET = "PUBLIC_COURSES_LIST_RESET";

export const PUBLIC_ATTENDEE_COURSE_REGISTER_REQUEST =
  "PUBLIC_ATTENDEE_COURSE_REGISTER_REQUEST";
export const PUBLIC_ATTENDEE_COURSE_REGISTER_SUCCESS =
  "PUBLIC_ATTENDEE_COURSE_REGISTER_SUCCESS";
export const PUBLIC_ATTENDEE_COURSE_REGISTER_FAIL =
  "PUBLIC_ATTENDEE_COURSE_REGISTER_FAIL";
export const PUBLIC_ATTENDEE_COURSE_REGISTER_RESET =
  "PUBLIC_ATTENDEE_COURSE_REGISTER_RESET";
